import {
  Box,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import type { PimoReactComponent } from "@pimo/pimo-app-builder";
import { ComponentTitleCard } from "@pimo/pimo-components";
import { Currency, DashboardFilterData, Profile } from "aint-types";
import { fireFilterEventWithTheProperPayloadBasedOnTrigger } from "aint-utils";

import {
  DashboardTitleCardSlots,
  DashboardTitleCardSlotsProps,
} from "./dashboard-title-card-slots";

export type ProjectOverviewCardProps = {
  title: string;
  filterData: DashboardFilterData;
  userProfile?: Profile;
  filterOptions?: {
    oeProjects?: string[];
    functions?: string[];
    LoBs?: string[];
    programs?: string[];
    enablers?: string[];
    regions?: string[];
    implementationPrograms?: string[];
  };
  localCurrency?: Currency;
  selectedCurrency?: Currency;
};

export const DashboardTitleCard: PimoReactComponent<
  ProjectOverviewCardProps,
  "filter:clear" | "filter:apply" | "currency:change",
  DashboardFilterData | Currency
> = ({
  fireEvent,
  title,
  filterData,
  filterOptions,
  localCurrency,
  selectedCurrency,
  ...props
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    fireEvent?.("currency:change", event.target.value as Currency);
  };
  return (
    <ComponentTitleCard
      title={title}
      endSlot={
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {localCurrency !== "EUR" && (
            <Box sx={{ minWidth: 120 }}>
              <FormControl
                variant="outlined"
                size="small"
                sx={{
                  minWidth: 100,
                  "& .MuiOutlinedInput-root": {
                    height: "100%",
                    borderRadius: "4px",
                    // match your button’s border color:
                    "& fieldset": { borderColor: "primary.main" },
                    // optional: darken on hover/focus
                    "&:hover fieldset": { borderColor: "primary.dark" },
                    "&.Mui-focused fieldset": { borderColor: "primary.dark" },
                  },
                }}
              >
                <Select
                  value={selectedCurrency || "EUR"}
                  onChange={handleChange as (event: SelectChangeEvent) => void}
                  // if you don’t want an InputLabel, use displayEmpty:
                  displayEmpty
                >
                  <MenuItem value="EUR">EUR</MenuItem>
                  <MenuItem value={localCurrency}>{localCurrency}</MenuItem>
                </Select>
              </FormControl>
            </Box>
          )}
          <DashboardTitleCardSlots
            {...(props as DashboardTitleCardSlotsProps)}
            handleFilterChange={(event, trigger) => {
              fireFilterEventWithTheProperPayloadBasedOnTrigger(
                trigger,
                filterData,
                event,
                fireEvent
              );
            }}
            clearAllFilters={() => fireEvent?.("filter:clear")}
            filterData={filterData}
            filterOptions={filterOptions}
          />
        </Box>
      }
    />
  );
};
